export default "assets/images/icons/cart-f72c9d46.svg";